// App Layout Component
// Main layout wrapper for content

import type { ReactNode } from 'react';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return <>{children}</>;
}
